// import Guid from '@/components/Guid'

export default class SubscriptionModel {
  constructor(companyId = '', userId = '', amount = 0, balance = 0, notes = '') {
    this.subscriptionId = 0 //Guid.newGuid()
    this.companyId = companyId
    const utcDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()
    this.purchaseDate = utcDate.split('.')[0] + 'Z'
    this.amount = amount
    this.previousBalance = balance
    this.notes = notes
    this.createdBy = userId
    this.createdDate = new Date().toISOString()
    this.modifiedby = userId
    this.modifiedDate = new Date().toISOString()
    this.deleted = false
  }
}
